var _a;
import Value from "./Value";
import Variation from "./Variation";
import Range from "./Range";
import GenericBenchmark from "./GenericBenchmark";
class SpreadGuidance {
    benchmark;
    floatingEquivalent;
    range;
    sofrEquivalent;
    value;
    variation;
    constructor(response) {
        this.benchmark = response.benchmark !== undefined ? new GenericBenchmark(response.benchmark) : undefined;
        this.floatingEquivalent = response.floatingEquivalent;
        this.range = response.range !== undefined ? new Range(response.range) : undefined;
        this.sofrEquivalent = response.sofrEquivalent;
        ;
        this.value = response.value !== undefined ? new Value(response.value) : undefined;
        this.variation = response.variation !== undefined ? new Variation(response.variation) : undefined;
    }
    #clone() {
        return new _a(this);
    }
    print() {
        const items = [];
        if (this.floatingEquivalent === true) {
            items.push(this.benchmark?.print() ?? '?');
            items.push("Equiv.");
            return items.join(" ");
        }
        if (this.sofrEquivalent === true) {
            return 'SOFR Equiv. (OLD)';
        }
        if (this.benchmark !== undefined) {
            items.push(this.benchmark.print() ?? '');
        }
        if (this.range !== undefined) {
            items.push(...this.range.printSpread());
        }
        else if (this.value !== undefined) {
            items.push(...this.value.printSpread());
        }
        if (this.variation !== undefined) {
            items.push(...this.variation.printSpread());
        }
        return items.join(' ');
    }
    updateFloatingEquivalent(value) {
        const clone = this.#clone();
        if (value) {
            clone.floatingEquivalent = !clone.floatingEquivalent;
        }
        else {
            delete clone.floatingEquivalent;
        }
        delete clone.range;
        delete clone.value;
        return clone;
    }
    updateSofrEquivalent() {
        const clone = this.#clone();
        clone.sofrEquivalent = !clone.sofrEquivalent;
        return clone;
    }
    updateBenchmark(newBenchmark) {
        const clone = this.#clone();
        clone.benchmark = newBenchmark;
        return clone;
    }
    updateRange(newRange) {
        const clone = this.#clone();
        clone.range = newRange;
        delete clone.value;
        delete clone.floatingEquivalent;
        return clone;
    }
    updateValue(newValue) {
        const clone = this.#clone();
        clone.value = newValue;
        delete clone.range;
        delete clone.floatingEquivalent;
        return clone;
    }
    updateVariation(newVariation) {
        const clone = this.#clone();
        clone.variation = newVariation;
        return clone;
    }
}
_a = SpreadGuidance;
export default SpreadGuidance;
